"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.describePinError = exports.isStrictlySequential = exports.isAllSameDigit = exports.CONSUMER_EMAIL_DOMAINS = void 0;
// Export all schemas
__exportStar(require("./schemas/auth"), exports);
__exportStar(require("./schemas/projects"), exports);
__exportStar(require("./schemas/common"), exports);
__exportStar(require("./schemas/file-assets"), exports);
var consumer_domains_1 = require("./schemas/consumer-domains");
Object.defineProperty(exports, "CONSUMER_EMAIL_DOMAINS", { enumerable: true, get: function () { return consumer_domains_1.CONSUMER_EMAIL_DOMAINS; } });
// Named re-exports from pin — `export *` through CommonJS compilation
// doesn't always register with rollup's static analyser in downstream
// bundlers, so we restate the names here explicitly.
var pin_1 = require("./schemas/pin");
Object.defineProperty(exports, "isAllSameDigit", { enumerable: true, get: function () { return pin_1.isAllSameDigit; } });
Object.defineProperty(exports, "isStrictlySequential", { enumerable: true, get: function () { return pin_1.isStrictlySequential; } });
Object.defineProperty(exports, "describePinError", { enumerable: true, get: function () { return pin_1.describePinError; } });
